import React from "react";

const ContentTypeContext = React.createContext();

export default ContentTypeContext;

export const ViewContextProvider = ContentTypeContext.Provider;
